'use client';
import React from 'react';

const reasons = [
  {
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
      </svg>
    ),
    title: 'Licensed Professional Guide',
    description: 'Officially licensed by the Moroccan Ministry of Tourism with 15+ years of experience guiding international visitors across Morocco.',
  },
  {
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    ),
    title: 'Luxury Vehicles',
    description: 'Travel in modern, air-conditioned luxury vehicles — Mercedes, premium SUVs, and minivans — maintained to the highest standards of comfort and safety.',
  },
  {
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
      </svg>
    ),
    title: 'Private Tours Only',
    description: 'We never mix groups. Every tour is exclusively private, ensuring your complete comfort, privacy, and a fully personalized experience.',
  },
  {
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
      </svg>
    ),
    title: 'Tailor-Made Itineraries',
    description: 'Every journey is designed from scratch around your interests, schedule, and preferences. No two tours are ever the same.',
  },
  {
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
      </svg>
    ),
    title: 'English, French, Arabic & Hebrew',
    description: 'Fluent in four languages, David ensures seamless communication and a deeply enriching experience for international visitors from any background.',
  },
  {
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    title: 'Deep Local Expertise',
    description: 'Born and raised in Morocco, David offers insider knowledge, authentic connections, and access to hidden gems that no guidebook can provide.',
  },
  {
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
      </svg>
    ),
    title: 'Safe & Secure Travel',
    description: 'Your safety is our absolute priority. All vehicles are fully insured, routes are carefully planned, and David maintains the highest standards of traveler security.',
  },
  {
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
      </svg>
    ),
    title: '5-Star Rated Service',
    description: 'Consistently rated 5 stars by travelers from around the world. Our commitment to excellence has earned us an outstanding reputation in luxury travel.',
  },
  {
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    title: 'Transparent Pricing',
    description: 'No hidden fees, no surprises. All pricing is clear and agreed upon in advance. You know exactly what you\'re paying for before your journey begins.',
  },
  {
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
      </svg>
    ),
    title: 'Personal Attention',
    description: 'David personally guides every tour. You will always have direct access to him via phone and WhatsApp before, during, and after your journey.',
  },
];

const stats = [
  { value: '500+', label: 'Happy Travelers', icon: '😊' },
  { value: '15+', label: 'Years Experience', icon: '⏳' },
  { value: '20+', label: 'Destinations', icon: '🗺️' },
  { value: '100%', label: 'Private Tours', icon: '🔒' },
];

export default function WhyChooseUs() {
  return (
    <section id="why-us" className="section-padding bg-cream">
      <div className="container-luxury">
        {/* Header */}
        <div className="text-center mb-16 animate-on-scroll">
          <span className="tag-gold">Why Choose Us</span>
          <h2 className="section-title mt-4 mb-4">
            The MoroccoJewishTours
            <br />
            <span className="text-gold italic">Difference</span>
          </h2>
          <div className="gold-divider" />
          <p className="section-subtitle mx-auto mt-4">
            When you choose MoroccoJewishTours, you choose expertise, elegance, and a deeply personal
            travel experience that no group tour can match.
          </p>
        </div>

        {/* Reasons Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
          {reasons?.map((reason, index) => (
            <div
              key={reason?.title}
              className="why-card animate-on-scroll"
              style={{ transitionDelay: `${(index % 5) * 80}ms` }}
            >
              <div className="w-12 h-12 bg-gold/10 flex items-center justify-center text-gold mb-4 group-hover:bg-gold group-hover:text-white transition-all duration-300">
                {reason?.icon}
              </div>
              <h3 className="font-serif text-base font-bold text-navy mb-2 group-hover:text-gold transition-colors duration-300">
                {reason?.title}
              </h3>
              <p className="font-sans text-xs text-gray-600 leading-relaxed">
                {reason?.description}
              </p>
            </div>
          ))}
        </div>

        {/* Trust Badges */}
        <div className="mt-16 bg-navy p-8 md:p-12 animate-on-scroll">
          <div className="text-center mb-8">
            <h3 className="font-serif text-2xl font-bold text-white">
              Trusted by Travelers from Around the World
            </h3>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            {stats?.map((stat) => (
              <div key={stat?.label}>
                <div className="text-3xl mb-2">{stat?.icon}</div>
                <div className="font-serif text-4xl font-bold text-gold mb-1">{stat?.value}</div>
                <div className="font-sans text-xs text-white/70 uppercase tracking-wider">{stat?.label}</div>
              </div>
            ))}
          </div>
          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <div className="flex items-center gap-2 bg-white/5 border border-white/10 px-5 py-3">
              <span className="text-gold text-lg">⭐⭐⭐⭐⭐</span>
              <span className="font-sans text-xs text-white/80">TripAdvisor Excellence</span>
            </div>
            <div className="flex items-center gap-2 bg-white/5 border border-white/10 px-5 py-3">
              <span className="text-gold text-lg">✓</span>
              <span className="font-sans text-xs text-white/80">Ministry of Tourism Licensed</span>
            </div>
            <div className="flex items-center gap-2 bg-white/5 border border-white/10 px-5 py-3">
              <span className="text-gold text-lg">💬</span>
              <span className="font-sans text-xs text-white/80">4 Languages Spoken</span>
            </div>
            <div className="flex items-center gap-2 bg-white/5 border border-white/10 px-5 py-3">
              <span className="text-gold text-lg">🔒</span>
              <span className="font-sans text-xs text-white/80">100% Private Tours</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
